import { render, staticRenderFns } from "./TransferSelector.vue?vue&type=template&id=72ab6ba4&scoped=true"
import script from "./TransferSelector.vue?vue&type=script&lang=js"
export * from "./TransferSelector.vue?vue&type=script&lang=js"
import style0 from "./TransferSelector.vue?vue&type=style&index=0&id=72ab6ba4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ab6ba4",
  null
  
)

export default component.exports